export default "__VITE_ASSET__QMhTA3iv__"